import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		note: {
			color: theme.palette.text.secondary,
			display: "block",
			marginTop: 4,
		},
		headerRow: {
			marginBottom: 8,
		},
		cityLabel: {
			fontWeight: 600,
		},
		cityAddressLink: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			textAlign: "left",
		},
	} satisfies Record<string, CSSObject>);
};
